import * as ActionTypes from '../store/ActionTypes';
import { axiosInstance } from './api';

export const actionCreators = {
    getSales: (sales) => ({ type: ActionTypes.getSales, payload: sales }),
    getSale: (sale) => ({ type: ActionTypes.getSale, payload: sale }),
    setSale: (sale) => ({ type: ActionTypes.getSale, payload: sale }),
    updateSale: (sale) => ({ type: ActionTypes.updateSale, payload: sale }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
    resendEmail: (response) => ({ type: ActionTypes.resendEmailSale, payload: response }),
};

export const getSales = (callback, context, filter) => {
    return dispatch => {
            const url = `Purchase/GetPurchaseByFilterAsync?filter=${filter}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getSales(response.data.data))
                callback(response, context);
            }).catch(response => { dispatch(actionCreators.updateResponse(response.response))});
    }
}

export const getSalesPaginated = (filter, pageNumber, pageSize,orderBy,descending) => {
    const url = `Purchase/GetPurchasesByFilterPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}`;
    return axiosInstance().get(url);
}

export const getSale = (callback, context, saleId) => {
    return dispatch => {
            const url = `Purchase/GetPurchaseById/${saleId}`;
            return axiosInstance().get(url).then(response => {
                dispatch(actionCreators.getSale(response.data.data))
                callback(response, context);
            }).catch(response => { dispatch(actionCreators.updateResponse(response.response))});
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const updateSale = (sale) => {
    return dispatch => {
        const url = `Purchase/PutAsync`;
        return axiosInstance().put(url, sale).then(response => {
            dispatch(actionCreators.updateSale(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const resendEmailService = (callback, context, id) => {
    return dispatch => {
        const url = `Purchase/PutResendEmailAsync/${id}`;
        return axiosInstance().put(url).then(response => {
            dispatch(actionCreators.resendEmail(response.data))
            callback(response, context)
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

